export default __webpack_public_path__ + "static/media/MTTK.4e8daf9f.MP4";